export const ditStatus = {
	None: "None",
	Gazin: "Gazin",
	Centauro: "Centauro",
	Both: "Both"
};
